"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.every.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _areEqual = _interopRequireDefault(require("fbjs/lib/areEqual"));

var _emptyFunction = _interopRequireDefault(require("fbjs/lib/emptyFunction"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _menu = _interopRequireDefault(require("../menu"));

var _propTypes2 = require("../constants/propTypes");

var _isLogin = require("../constants/isLogin");

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__sidebar-index__root",
  "menu": "meepshop-meep-ui__sidebar-index__menu",
  "showArrow": "meepshop-meep-ui__sidebar-index__showArrow"
};

var Sidebar = (0, _DecoratorsRoot.enhancer)(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Sidebar, _React$PureComponent);

  var _super = _createSuper(Sidebar);

  function Sidebar() {
    var _this;

    (0, _classCallCheck2["default"])(this, Sidebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      openKeys: []
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPages", (0, _memoizeOne["default"])(function (pages, isLogin) {
      if (isLogin === _isLogin.NOTLOGIN) return pages;
      var member = pages.find(function (_ref) {
        var action = _ref.action;
        return action === 8;
      });
      if (!member) return pages;
      return [member].concat((0, _toConsumableArray2["default"])(pages.filter(function (_ref2) {
        var action = _ref2.action;
        return action !== 8;
      })));
    }, _areEqual["default"]));
    return _this;
  }

  (0, _createClass2["default"])(Sidebar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isLogin = _this$props.isLogin,
          menu = _this$props.menu,
          children = _this$props.children;
      var openKeys = this.state.openKeys;
      if (!menu) return children;
      var iconSize = menu.iconSize,
          pages = menu.pages,
          _menu$design = menu.design,
          width = _menu$design.width,
          paddingTop = _menu$design.paddingTop,
          expandSubItem = _menu$design.expandSubItem,
          design = (0, _objectWithoutProperties2["default"])(_menu$design, ["width", "paddingTop", "expandSubItem"]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.root
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: "".concat(width, "px")
        }
      }, /*#__PURE__*/_react["default"].createElement(_menu["default"], {
        id: "sidebar",
        className: "".concat(styles.menu, " ").concat(expandSubItem ? '' : "".concat(styles.showArrow, " show-hover"), " show-border"),
        pages: this.getPages(pages, isLogin),
        design: _objectSpread(_objectSpread({}, design), {}, {
          width: width,
          height: 0,
          expandSubItem: true
        }),
        openKeys: expandSubItem ? null : openKeys,
        onOpenChange: expandSubItem ? _emptyFunction["default"] : function (newOpenKeys) {
          var latestOpenKey = newOpenKeys.find(function (key) {
            return !openKeys.includes(key);
          });
          if (pages.every(function (_ref3) {
            var pageId = _ref3.id;
            return pageId !== latestOpenKey;
          })) _this2.setState({
            openKeys: newOpenKeys
          });else _this2.setState({
            openKeys: latestOpenKey ? [latestOpenKey] : []
          });
        },
        iconSize: iconSize,
        reverseSearch: true,
        hasLevelThree: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: "calc(100% - ".concat(width, "px)"),
          display: 'flex',
          flexDirection: 'column'
        }
      }, children), /*#__PURE__*/_react["default"].createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "\n              #menu-sidebar > .ant-menu {\n                margin: ".concat(paddingTop, "px 0px 0px;\n              }\n            ")
        }
      }));
    }
  }]);
  return Sidebar;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** context */
  isLogin: _propTypes2.ISLOGIN_TYPE.isRequired,

  /** props */
  menu: _propTypes["default"].shape({
    iconSize: _propTypes["default"].oneOf([24, 32, 48]).isRequired,
    pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes2.ID_TYPE.isRequired
    }).isRequired),
    design: _propTypes["default"].shape({
      width: _propTypes2.POSITIVE_NUMBER_TYPE.isRequired,
      paddingTop: _propTypes2.POSITIVE_NUMBER_TYPE.isRequired
    }).isRequired
  }).isRequired,
  children: _propTypes["default"].node.isRequired
}), _temp)) || _class;

exports["default"] = Sidebar;